import React from 'react';
import { Info } from 'lucide-react';
import { getTooltipForSlot } from '../../config/ForensicTaxonomy';

export default function ForensicTooltip({ slotName }) {
  const match = getTooltipForSlot(slotName);
  if (!match) return null;

  return (
    <span className="group relative inline-flex items-center ml-1 cursor-help">
      <Info className="w-3.5 h-3.5 text-blue-500 shrink-0" />
      <span className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 rounded-lg bg-[#20243B] p-3 text-white text-xs shadow-xl opacity-0 transition-opacity duration-200 group-hover:opacity-100 group-hover:pointer-events-auto z-50">
        <span className="block font-bold text-[#C5A059] mb-1">{match.title}</span>
        <span className="block leading-relaxed">{match.text}</span>
        <span className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-[#20243B]" />
      </span>
    </span>
  );
}
